import React from 'react';
import { connect } from 'react-redux';
import { LocalizedMessage } from 'intl/LocalizedComponents';
import _size from 'lodash/size';
import PropTypes from 'prop-types';
// Models
import mCustomer from 'models/customer';
// Custom
import { getInstallationCustomersAutocomplete } from 'actions';
import { customerDataShape, autoCompleteDataShape } from 'constants/PropTypesShapes';
import AutoCompleteSearchFieldFilter from 'components/filters/AutoCompleteSearchFieldFilter';
import InformationItem from 'components/items/InformationItem';

const CustomerAutoCompleteItem = ({ element, onSelect }) => {
  if (element) {
    const customer = { ...element };

    return (
      <div className="information-item-wrapper">
        <InformationItem
          icon="itemCustomer"
          label={<LocalizedMessage id="info.accessWaysQuantity" values={{ quantity: _size(customer.access_ways) }} />}
          value={mCustomer.fullName(customer)}
          onClick={() => onSelect(customer)}
        />
      </div>
    );
  }
  return null;
};

CustomerAutoCompleteItem.propTypes = {
  element: customerDataShape,
  onSelect: PropTypes.func,
};

CustomerAutoCompleteItem.defaultProps = {
  element: null,
  onSelect: null,
};

class CustomerAutoCompleteFilter extends React.Component {
  constructor(props) {
    super(props);

    this.handleGetCustomers = this.handleGetCustomers.bind(this);
    this.handleSelectElement = this.handleSelectElement.bind(this);
  }

  // Handlers
  handleGetCustomers(value, page) {
    const { id, handleGetCustomersAutocomplete } = this.props;
    // Get default customers list features
    const { defaultParams: { pagination, sort }, autoCompleteFilter } = mCustomer.listFeatures();
    // Define the page to be loaded
    const finalPagination = {
      page: page || pagination.page,
      pageSize: pagination.pageSize,
    };
    // Launch customers loading
    const filter = { ...autoCompleteFilter, value };
    handleGetCustomersAutocomplete(id, finalPagination, sort, [filter]);
  }

  handleSelectElement(customer) {
    const { onSelect } = this.props;
    onSelect(customer);
  }

  render() {
    const { customer, customers: { loading, elements, pagination } } = this.props;

    return (
      <AutoCompleteSearchFieldFilter
        label="field.customer"
        element={customer}
        loading={loading}
        elements={elements}
        pagination={pagination}
        elementComp={
          <CustomerAutoCompleteItem />
        }
        onGetElements={this.handleGetCustomers}
        elementDescBuilder={(element) => (element.lastname)}
        onSelectElement={this.handleSelectElement}
      />
    );
  }
}

CustomerAutoCompleteFilter.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  customer: customerDataShape,
  customers: autoCompleteDataShape.isRequired,
  onSelect: PropTypes.func.isRequired,
  handleGetCustomersAutocomplete: PropTypes.func.isRequired,
};

CustomerAutoCompleteFilter.defaultProps = {
  customer: null,
};

const mapStateToProps = (state) => ({
  customers: state.autoComplete.customers,
});

const mapDispatchToProps = (dispatch) => ({
  handleGetCustomersAutocomplete: (id, pagination, sort, filters) => {
    dispatch(getInstallationCustomersAutocomplete(id, pagination, sort, filters));
  },
});

module.exports = connect(
  mapStateToProps,
  mapDispatchToProps,
)(CustomerAutoCompleteFilter);



// WEBPACK FOOTER //
// ./routes/app/routes/installations/assets/customers/CustomerAutoCompleteFilter.js